/* 검색바가 헤더 바로 아래에 붙도록 `--nt-search-top` 을 **실측해서** 채운다.
 *
 * ⚠️⚠️ 전에는 CSS 에 `top: 110px`(PC) · `89px`(MOB) 를 적어 뒀는데, 그 값은
 *    "띠배너 39 + 헤더 71" 을 1280 에서 한 번 재서 굳힌 것이다. 헤더 높이는
 *    브레이크포인트마다 다르고(§11 이 글자·로고 크기를 바꾼다) 데스크톱↔모바일
 *    전환 지점도 CSS 파일마다 다를 수 있어, 어긋나면 **검색바가 헤더를 덮는다**
 *    (검색바 z-index 11 > 헤더 그룹 3).
 *
 * 계산: 헤더 섹션의 `sticky top`(띠배너 높이만큼 내려온 값) + 헤더 섹션 높이.
 * ⚠️ 띠배너 높이를 따로 더하지 않는다 — 그건 이미 헤더의 `sticky top` 에 들어 있다.
 *    따로 더하면 두 번 세어 검색바가 아래로 밀린다.
 */
(() => {
  const root = document.documentElement;

  const headerSection = () => {
    const hw = document.querySelector('.header-wrapper');
    return hw ? hw.closest('.shopify-section') || hw : null;
  };

  const update = () => {
    const el = headerSection();
    if (!el) return;
    const cs = getComputedStyle(el);
    /* `sticky` 가 아니면 `top` 은 레이아웃에 쓰이지 않는 값이라 더하면 안 된다. */
    const stickyTop = cs.position === 'sticky' ? parseFloat(cs.top) || 0 : 0;
    root.style.setProperty('--nt-search-top', `${stickyTop + el.getBoundingClientRect().height}px`);
  };

  update();

  addEventListener('resize', update);
  /* 모바일 회전은 `resize` 를 못 내보내는 브라우저가 있다. */
  addEventListener('orientationchange', update);
  /* 테마 에디터에서 헤더를 편집하면 높이가 바뀐다. */
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', update);

  if (window.ResizeObserver) {
    const ro = new ResizeObserver(update);
    /* 글꼴·로고 이미지가 늦게 로드되면 헤더 높이가 한 번 더 바뀐다. */
    const el = headerSection();
    if (el) ro.observe(el);
    /* 뷰포트 폭이 바뀌면 헤더가 데스크톱↔모바일로 갈린다 — `resize` 를 놓쳐도 여기서 잡는다. */
    ro.observe(document.documentElement);
  }

  /* ⚠️ 검증 메모: 브라우저 자동화 도구의 뷰포트 에뮬레이션은 `resize` 도 ResizeObserver 도
     발동시키지 않는 경우가 있다(실제로 겪었다 — 폭을 바꿔도 변수가 그대로였다).
     그때는 **폭을 바꾼 뒤 페이지를 새로 열어** 확인할 것. 초기 계산은 항상 정확하다. */
})();
